export const FORM_ID = "menu.payments";
export const FORM_TICKET = "services.newPayment";
export const FORM_SUMMARY = "pay.paymentAFIP.summary";
export const FORM_LIST_ID = "payments.afip.list";
export const DETAIL_URL = "/agenda/multiplePayment/detail";
